// extracted by mini-css-extract-plugin
export var defaultWrapper = "_gm-3";
export var downloadButton = "_gm-4";
export var fileContainer = "_gm-9 _gm-7";
export var fileContainerBase = "_gm-7";
export var fileContainerFixedHeight = "_gm-8 _gm-7";
export var fileInfo = "_gm-5";
export var fileInfoWidthRestricted = "_gm-6";
export var fileType = "_gm-1";
export var fileTypeName = "_gm-2";
export var image = "_gm-0";
export var link = "_gm-b";
export var overflowEllipsis = "_gm-a";